import { useChatContext } from '@/context/ChatContext'
import { useHeaderContext } from '@/context/HeaderContext'
import { cn } from '@/lib/utils'

type IndicatorProps = {
  label: string
}

export default function Indicator({ label }: IndicatorProps) {
  const { theme } = useHeaderContext()
  const { showSearch } = useChatContext()

  return (
    <div
      className={cn(
        'hidden h-4 items-center justify-center rounded-key border-[0.75px] px-1 text-[10px] font-medium leading-none navigation:flex',
        label.length === 1 && 'w-4',
        theme === 'light' || showSearch
          ? 'border-black/10 bg-black/10 text-black/50 dark:border-white/10 dark:bg-white/10 dark:text-white/80'
          : 'border-white/10 bg-white/10 text-white/80',
      )}
    >
      {label}
    </div>
  )
}
